<template>
  <div class="checkbox">
    <label class="checkbox-container">
      <input type="checkbox" :id="name" :value="checked" @input="onChange" />
      <span class="checkmark"></span>
    </label>
    <label v-if="label" :for="name">
      {{ label }}
    </label>
  </div>
</template>

<script>
/* Reusable checkbox with optional label. */

export default {
  name: 'Checkbox',
  components: {},
  props: {
    // Unique name that is not shared by any other input on the page
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.checked = this.value
  },
  data() {
    return {
      checked: false,
    }
  },
  methods: {
    onChange() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1.25rem;
}

/* Customize the label (the checkbox-container) */
.checkbox-container {
  display: block;
  position: relative;
  padding: 1.25rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: $soft-gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: $mid-gray;
}

/* When the checkbox is checked, add a dark background */
.checkbox-container input:checked ~ .checkmark {
  background-color: var(--dark-brand-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
